<template>
  <div class="navigationLayout d-flex  row">
    <!-- <button @click="$emit('set-page', 3)">Change page num</button> -->
    <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
      <button
        class="btn btn-outline-secondary btn-block"
        id="prev-page"
        @click="onPrevPage"
      >
        <span class="prev_next">&#8249;&#8249; </span>
        <span class="prev-page">Prev</span>
      </button>
    </div>
    <div
      id="page_info"
      class="col-5 col-sm-5 col-md-4 col-lg-4 col-xl-5 d-flex row set_page_num"
    >
      <span class="page_num_set">Set the page number</span>
      <div class="page-info">Page:</div>

      <div class="">
        <b-input-group size="sm" class="input_group">
          <b-form-input
            type="text"
            v-model="pageNumber"
            class="input-page-num"
            v-on:keyup.enter="newPageNumber"
          >
          </b-form-input>

          <b-input-group-append>
            <b-button class="form_button" @click="newPageNumber">ok</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-modal
          id="page_not_exist"
          ref="modalPageNumberNotExist"
          title="Wrong page number"
          ok-only
        >
          <p class="my-4">
            The requested page number does not exist in this PDF.
            <br />
            Please, choose one number between 1 and 300.
          </p>
        </b-modal>
      </div>

      <div class="page_count">
        of
        <span id="page-count">{{ numPages }}</span>
      </div>
    </div>

    <div class="col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3">
      <button
        class="btn btn-outline-secondary btn-block"
        id="next-page"
        @click="onNextPage"
      >
        <span class="next-page">Next</span
        ><span class="prev_next"> &#8250;&#8250;</span>
      </button>
    </div>
    <div></div>
    <MenuBar
      class="col-1 col-sm-1 col-md-2 col-lg-2 col-xl-1 menu_bar"
      :pageNum="pageNum"
      :fulltextpdf="fulltextpdf"
      :numPages="numPages"
      :url="url"
    />
  </div>
</template>

<script>
import MenuBar from "./MenuBar.vue";
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import * as pdfjsViewer from "pdfjs-dist/web/pdf_viewer.js";

import $ from "jquery";

export default {
  name: "PageNavigations",
  components: {
    MenuBar,
  },

  data() {
    return {
      loadingTask: "",
      fulltextpdf: "",
      pdfDoc: null,
      pageRendering: false,
      pageNumPending: null,
      pageNum: 1,

      numPages: null,
      data: "",
      videosInPage: false,
      urlNum: null,
      url: window.location.href,
      pageNumber: 1,
    };
  },
  created() {
    window.addEventListener("resize", () => {
      this.renderPage(this.pageNum);
    });
  },

  methods: {
    newPageNumber: function() {
      this.pageNumber = parseInt($(".input-page-num")[0].value);

      if (this.pageNumber != this.pageNum) {
        this.pageNum = this.pageNumber;

        if (this.pageNum >= 1 && this.pageNum <= 300) {
          this.renderPage(this.pageNumber);
        }
      }
    },

    renderPage: function(num) {
      this.pageRendering = true;
      const container = $("#pageContainer")[0];

      container.innerHTML = "";
      var eventBus = new pdfjsViewer.EventBus();
      this.pdfDoc.getPage(num).then((page) => {
        const pdfLayoutWidth = $("#pdfLayout")[0].getBoundingClientRect().width;

        let scale = (pdfLayoutWidth * 0.747) / page.view[2];
        var pdfPageView = new pdfjsViewer.PDFPageView({
          container: container,
          id: this.pageNum,
          scale: scale,
          eventBus: eventBus,
          defaultViewport: page.getViewport({ scale: scale }),
          textLayerFactory: new pdfjsViewer.DefaultTextLayerFactory(),
          annotationLayerFactory: new pdfjsViewer.DefaultAnnotationLayerFactory(),
        });

        pdfPageView.setPdfPage(page);
        this.pageRendering = false;
        return pdfPageView.draw();
      });

      document.getElementsByClassName("input-page-num").textContent = num;

      this.pageNum = num;

      this.$emit("set-page", this.pageNum);
    },

    queueRenderPage: function(num) {
      if (this.pageRendering) {
        this.pageNumPending = num;
      } else {
        this.renderPage(num);
      }
    },

    onPrevPage: function() {
      if (this.pageNum <= 1 || this.pageNum > this.pdfDoc.numPages) {
        return;
      }

      this.pageNum--;

      this.queueRenderPage(this.pageNum);
    },

    onNextPage: function() {
      if (this.pageNum < 1 || this.pageNum >= this.pdfDoc.numPages) {
        return;
      }

      this.pageNum++;

      this.queueRenderPage(this.pageNum);
    },
  },

  mounted() {
    this.url = window.location.href;
    let urlNum = parseInt(this.url.split("/p").pop());

    if (isNaN(urlNum)) {
      this.pageNum = 1;
    } else {
      this.pageNum = urlNum;
    }

    pdfjsLib.GlobalWorkerOptions.workerSrc =
      this.$root.$data.url + "/nondobs/pdfviewer/build/pdf.worker.js";

    this.fulltextpdf =
      window.location.origin +
      "/nondobs/Fleischmann_Tradition_and_Craft_For_Screen_Reading.pdf";
    var CMAP_URL = "../../node_modules/pdfjs-dist/cmaps/";
    var CMAP_PACKED = true;

    this.loadingTask = pdfjsLib.getDocument({
      url: this.fulltextpdf,
      cMapUrl: CMAP_URL,
      cMapPacked: CMAP_PACKED,
    });
    this.loadingTask.promise.then((pdf) => {
      this.pdfDoc = pdf;

      this.numPages = this.pdfDoc.numPages;

      if (this.pageNum >= 1 && this.pageNum <= 300) {
        this.renderPage(this.pageNum);
      }
    });
  },
  watch: {
    pageNum: function() {
      this.pageNumber = this.pageNum;
      if (this.pageNum < 1 || this.pageNum > 300) {
        this.$refs["modalPageNumberNotExist"].show();
      }
    },
  },
};
</script>

<style scoped>
.page_num_set {
  visibility: hidden;
  width: 170px;
  background-color: #8c8c8c;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 43px;
}
.set_page_num:hover .page_num_set {
  visibility: visible;
}
#page-count {
  font-weight: bold;
}
#page_info {
  align-items: center;
  justify-content: center;
  padding-left: 5px;
  padding-right: 5px;
  margin: 0px;
  font-size: 15px;
}

.menu_bar {
  padding: 0px;
}
.input_group {
  height: auto;
  padding: 5px;
}
.form_button {
  margin: 0px;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.1);
}
.form_button:active {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.form_button:hover {
  background-color: rgba(0, 0, 0, 0.25);
}
#page_not_exist {
  text-align: center;
}
.input-page-num {
  padding: 5px;
  height: auto;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  width: 40px;
}
.prev_next {
  font-size: 19px;
  padding: 0px;
  margin: 0px;
}
div.col {
  padding: 5px 0px;
}
.navigationLayout {
  /* min-height: 20vh; */
  margin: 0px;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
}

button#prev-page {
  font-size: inherit;
  font-weight: bold;
  margin: 0px;
  padding: 5px;
  width: 80%;
  float: left;
}
button#next-page {
  font-size: inherit;
  font-weight: bold;
  margin: 0px;
  padding: 5px;
  width: 80%;
  float: right;
}
@media (max-width: 1200px) {
  .navigationLayout {
    margin: 5px 0px;
    padding: 10px;
    align-items: center !important;
    justify-content: space-around !important;
    height: fit-content;
  }
}
@media (max-width: 768px) {
  .page-info {
    font-size: 13px !important;
    display: block;
  }
}

@media (max-width: 600px) {
  button#prev-page {
    font-size: 13px;
    width: 80%;
    margin-left: 0px;
  }
  button#next-page {
    font-size: 13px;
    width: 80%;
    margin-right: 0px;
  }
  #page-info {
    font-size: 13px;
  }
  .input-page-num {
    font-size: 13px;
    font-weight: bold;
    width: 35px;
  }
  .form_button {
    font-size: 13px !important;
  }
  .page_count {
    font-size: 13px;
  }
  .page-info {
    display: none;
  }
}
@media (max-width: 363px) {
  button#prev-page {
    font-size: 9px;
    margin-left: 0px;
    width: 80%;
  }
  button#next-page {
    font-size: 9px;

    margin-right: 0px;
    width: 80%;
  }
  .prev_next {
    font-size: 12px;
  }
  #page-info {
    font-size: 11px;
  }
  .input-page-num {
    font-size: 11px;
    font-weight: bold;
    width: 30px;
  }
  .form_button {
    font-size: 11px !important;
  }
  .page_count {
    font-size: 11px;
  }
}
@media (max-width: 288px) {
  .prev_next {
    font-size: 19px;
  }

  button#prev-page {
    font-size: 8px;
    margin-left: 0px;
  }
  button#next-page {
    font-size: 8px;
    margin-right: 0px;
  }
  span.prev-page {
    display: none;
  }
  span.next-page {
    display: none;
  }
}
button {
  color: black;
  text-decoration: none;
  border: 1px solid rgba(0, 0, 0, 0.125);
  background-color: transparent;
  font-size: 20px;
  padding: 5px;
  /* margin: 0px 20px 0px 20px; */
}

button:hover {
  background-color: rgba(0, 0, 0, 0.25);
}
button:active {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
div.col-4 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
div.col-3 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
</style>
